// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2X4JN","dragIcon":"SortableItem_dragIcon__2VHA3","disabled":"SortableItem_disabled__3EVa-"};